module.exports = __webpack_public_path__ + "img/test_submitted.735eb6f8.svg";